import { useEffect, useState } from 'react';

export interface VisualViewportState {
  readonly height: number;
  readonly offsetTop: number;
  readonly keyboardOpen: boolean;
}

function readViewport(): VisualViewportState {
  const viewport = window.visualViewport;
  const height = viewport?.height ?? window.innerHeight;
  return {
    height,
    offsetTop: viewport?.offsetTop ?? 0,
    keyboardOpen: window.innerHeight - height > 160,
  };
}

export function useVisualViewport(): VisualViewportState {
  const [state, setState] = useState<VisualViewportState>(() => readViewport());

  useEffect(() => {
    const viewport = window.visualViewport;
    const update = () => {
      const next = readViewport();
      document.documentElement.style.setProperty('--visual-viewport-height', `${next.height}px`);
      document.documentElement.classList.toggle('keyboard-open', next.keyboardOpen);
      setState(next);
    };
    update();
    viewport?.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      viewport?.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      document.documentElement.classList.remove('keyboard-open');
    };
  }, []);

  return state;
}
